export const DOMAIN = 'https://betonmobiledescantons.com';
export const BRAND = 'Béton Mobile des Cantons inc.';